import { query } from './query';

export function isImagesLoaded(
  parentElement: HTMLElement | Document = document,
): boolean {
  return query('img', parentElement).every(
    (image: HTMLImageElement) => image.complete,
  );
}
